/**
 * @fileoverview gRPC-Web generated client stub for adx.page
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.adx = {};
proto.adx.page = require('./page_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.page.PageClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.adx.page.PagePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.page.AdPagesListRequest,
 *   !proto.adx.page.AdPagesListResponse>}
 */
const methodDescriptor_Page_GetAdPagesList = new grpc.web.MethodDescriptor(
  '/adx.page.Page/GetAdPagesList',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.page.AdPagesListRequest,
  proto.adx.page.AdPagesListResponse,
  /**
   * @param {!proto.adx.page.AdPagesListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.page.AdPagesListResponse.deserializeBinary
);


/**
 * @param {!proto.adx.page.AdPagesListRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.page.AdPagesListResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.page.PageClient.prototype.getAdPagesList =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.page.Page/GetAdPagesList',
      request,
      metadata || {},
      methodDescriptor_Page_GetAdPagesList);
};


/**
 * @param {!proto.adx.page.AdPagesListRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.page.AdPagesListResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.page.PagePromiseClient.prototype.getAdPagesList =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.page.Page/GetAdPagesList',
      request,
      metadata || {},
      methodDescriptor_Page_GetAdPagesList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.adx.page.AdPageComponentsRequest,
 *   !proto.adx.page.AdPageComponentsResponse>}
 */
const methodDescriptor_Page_GetAdPageComponents = new grpc.web.MethodDescriptor(
  '/adx.page.Page/GetAdPageComponents',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.adx.page.AdPageComponentsRequest,
  proto.adx.page.AdPageComponentsResponse,
  /**
   * @param {!proto.adx.page.AdPageComponentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.adx.page.AdPageComponentsResponse.deserializeBinary
);


/**
 * @param {!proto.adx.page.AdPageComponentsRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.page.AdPageComponentsResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.page.PageClient.prototype.getAdPageComponents =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.page.Page/GetAdPageComponents',
      request,
      metadata || {},
      methodDescriptor_Page_GetAdPageComponents);
};


/**
 * @param {!proto.adx.page.AdPageComponentsRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.adx.page.AdPageComponentsResponse>}
 *     The XHR Node Readable Stream
 */
proto.adx.page.PagePromiseClient.prototype.getAdPageComponents =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/adx.page.Page/GetAdPageComponents',
      request,
      metadata || {},
      methodDescriptor_Page_GetAdPageComponents);
};


module.exports = proto.adx.page;

